import LineLoader from "@/components/line-loader";
import { useGetCardPurchases } from "@/hooks/use-queries";
import { useEffect, useState } from "react";
import { DataTable } from "./admin-dashboard/_misc/data-table";
import { cardTransactionsColumns } from "./admin-dashboard/transactions/_misc/cardColumn";
import moment from "moment";
import { useParams } from "react-router-dom";

const Account = () => {
  const { id } = useParams();
  const [paginationParams, setPaginationParams] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [pageCount, setPageCount] = useState(1);
  const { data: cards, isLoading: isCardLoading } = useGetCardPurchases({
    id: id,
    filters: {
      page: paginationParams.pageIndex,
      limit: paginationParams.pageSize,
      startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    },
  });

  useEffect(() => {
    setPageCount(cards?.pageTotal || 1);
  }, [cards]);

  return (
    <div>
      <header className="flex items-center justify-between">
        <div>
          <p className="text-lg">My Account</p>
          <p className="text-3xl leading-4 font-bold">Card Purchase History</p>
        </div>
      </header>

      <div className="mt-8 rounded-xl bg-white p-4">
        <h3 className="text-xl font-semibold">History</h3>
        <div className="mt-6 text-sm lg:text-base">
          <div className="mt-4">
            {isCardLoading ? (
              <div className="h-1">
                <LineLoader />
              </div>
            ) : (
              <DataTable
                columns={cardTransactionsColumns}
                data={cards?.data || []}
                pagination={{
                  ...paginationParams,
                  pageIndex: paginationParams.pageIndex + 1,
                }}
                setPagination={setPaginationParams}
                pageCount={pageCount}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Account;
